define(["dojo/i18n", "/local/buildagent/work/71550ad6d48e14da/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/local/buildagent/work/71550ad6d48e14da/target/debug/2P/derived/ui/mw-browser-utils/l10n/nls/unsupportedErrorPage.js?absMid=mw-browser-utils/l10n/nls/unsupportedErrorPage"
], function(loader, runner) {
   return runner(loader, "mw-browser-utils/l10n/nls/unsupportedErrorPage", __webpack_require__.dj.c(), true);
});